import script from "./web-home.vue?vue&type=script&setup=true&lang=js"
export * from "./web-home.vue?vue&type=script&setup=true&lang=js"

import "./web-home.vue?vue&type=style&index=0&id=012d3df4&lang=scss"

const __exports__ = script;

export default __exports__